import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer'
import { extrudeSettings } from '../../../../../../utils/Functions'
import HandleOneModel from '../../../ShareModel/HandleModel/HandleOneModel'

const StandardWalkInBrownDoor = ({ width, height, trimWidth, doorColor, isOverlap, overlapTrimColor, handlePlacement, handleModel }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])


    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();

        return model;
    }, [width, height, trimWidth])
    
    const doorModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.closePath();

        return model
    }, [width, height, trimWidth])
    
    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={isOverlap ? overlapTrimColor : trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh position={[0, 0, 0.05]}>
                <extrudeGeometry args={[doorModel, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.5} toneMapped={false} emissive={'#101010'} />
            </mesh>
            <HandleOneModel handlePlacement={handlePlacement} width={width}  />
        </>
    )
}

export default StandardWalkInBrownDoor